import appConfig from '@nerdwallet/app-config';
import { HOMEPAGE as analyticsBase } from '../analytics-constants';

export default [
  {
    badge: {
      url: `${appConfig.ASSETS_URL}/images/homepage/boa_2024_badge.png`,
      height: 86,
      width: 67,
      top: true,
      alt: 'BOA 2024',
    },
    subtitle:
      'The list is here — see our Nerds’ top credit cards, personal\nloans, and more.',
    ctaButtonText: 'SHOP NOW',
    ctaLinkUrl: '/l/awards',
    elementImpressionEntityName:
      analyticsBase.entity_names.secondary_campaign_module, // used for the Impression of the component
    elementImpressionSectionName: analyticsBase.section_name,
    instrumentationKey: 'boa_2024',
    trkQueryParam: analyticsBase.entity_names.secondary_campaign_module,
  },
  {
    badge: {
      url: `${appConfig.ASSETS_URL}/images/homepage/nw_advisors_badge.png`,
      height: 17,
      width: 211,
      top: false,
      alt: 'NW ADVISORS',
    },
    subtitle:
      'Need more guidance? Get unlimited 1:1 advice from a\nCertified Financial Planner™.',
    ctaButtonText: 'JOIN FOR $30/MONTH',
    ctaLinkUrl: 'http://nerdwalletadvisors.com',
    elementImpressionEntityName:
      analyticsBase.entity_names.secondary_campaign_module, // used for the Impression of the component
    elementImpressionSectionName: analyticsBase.section_name,
    instrumentationKey: 'nw_advisors',
    trkQueryParam: analyticsBase.entity_names.secondary_campaign_module,
    singleLayout: {
      titleImage: `${appConfig.ASSETS_URL}/images/homepage/nw_advisors.png`,
      visualBackgroundImageMobileUrl: `${appConfig.ASSETS_URL}/images/homepage/nw_advisors_mobile.png`,
      visualBackgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/homepage-nw-advisor-1280.jpg`,
      backgroundColor: '#EEF7FF',
      backgroundColorMobile: '#DEEFFF',
    },
  },
];
